import { Component, OnInit } from "@angular/core";
import { WorkDomainService } from "../../../../auth/service/work-domain.service";
import { AuthenticationService } from "../../../../auth/service";
import { UtilsService } from "../../../../auth/service/utils.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { IWorkDomain } from "app/auth/models/work-domain";

@Component({
  selector: "app-domain-list",
  templateUrl: "./domain-list.component.html",
  styleUrls: ["./domain-list.component.scss"],
})
export class DomainListComponent implements OnInit {
  public contentHeader: IContentHeader;
  public domainList: IWorkDomain[] = [];
  public searchKey: string = "";
  public filteredDomain: IWorkDomain[] = [];
  public new_domain: string;
  public currentDomain: IWorkDomain;
  public showModalError: boolean = false;

  constructor(
    private _workDomainService: WorkDomainService,
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    public _modalService: NgbModal,
    private router: Router,
  ) {}

  async ngOnInit() {
    this.contentHeader = {
      headerTitle: "MENU.DOMAIN",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.MANAGE",
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: "MENU.DOMAIN",
            isLink: false,
          },
        ],
      },
    };
    await this.loadDomainList();
    await this.searchDomain();
  }

  async loadDomainList() {
    this.domainList = await this._workDomainService.getList();
  }

  async searchDomain() {
    const key: string = this.searchKey.trim().toLowerCase();
    let filteredDomain: IWorkDomain[] = this.domainList;
    if (key.length > 0) {
      filteredDomain = filteredDomain.filter((item: IWorkDomain) => {
        return item.name.toLowerCase().includes(key);
      });
    }
    this.filteredDomain = filteredDomain;
  }

  public modalOpen(modalBasic, currentDomain) {
    this.new_domain = "";
    this._modalService.open(modalBasic, {
      size: "sm",
      centered: true,
    });
    this.currentDomain = JSON.parse(JSON.stringify(currentDomain));
    this.showModalError = false;
  }

  async addDomain() {
    if (!this._authenticationService.hasCapability("create_workdomain")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    if (!!this.new_domain) {
      this.new_domain = this.new_domain.trim();
    }

    if (!this.new_domain || this.new_domain.length < 1) {
      this.showModalError = true;
      return false;
    }

    let data = {
      name: this.new_domain,
    };
    this._utilService.showLoading();
    await this._workDomainService
      .createDomain(data)
      .then(async () => {
        this._utilService.hideLoading();
        await this.loadDomainList();
        await this.searchDomain();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_UPLOAD_DOMAIN" });
        this._modalService.dismissAll();
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_UPLOAD_DOMAIN" });
      });
    this.new_domain = "";
    this._modalService.dismissAll();
  }

  async editDomain() {
    if (!this._authenticationService.hasCapability("edit_workdomain")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    if (!!this.currentDomain.name) {
      this.currentDomain.name = this.currentDomain.name.trim();
    }
    if (!this.currentDomain.name || this.currentDomain.name.length < 1) {
      this.showModalError = true;
      return false;
    }

    let data: IWorkDomain = {
      name: this.currentDomain.name,
    };
    this._utilService.showLoading();
    await this._workDomainService
      .updateDomain(this.currentDomain.id, data)
      .then(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_DOMAIN" });
        await this.loadDomainList();
        await this.searchDomain();
        this._modalService.dismissAll();
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_EDIT_DOMAIN" });
      });
  }

  async delete(domain: IWorkDomain) {
    if (!this._authenticationService.hasCapability("delete_workdomain")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += ` ${domain.name}`;

    await this._utilService
      .showSWALDeleteConfirmation({ text: deleteText })
      .then(async (result) => {
        if (result.value) {
          this._utilService.showLoading();
          await this._workDomainService
            .deleteDomain(domain.id)
            .then(async () => {
              this._utilService.hideLoading();
              await this._utilService.showSWALSuccess({ text: "SUCCESS_DELETE_CUSTOMER" });
              this.filteredDomain = this.filteredDomain.filter((item) => item.id != domain.id);
              this.domainList = this.domainList.filter((item) => item.id != domain.id);
            })
            .catch(async () => {
              this._utilService.hideLoading();
              await this._utilService.showSWALError({ text: "ERROR_DELETE_CUSTOMER" });
            });
        } else if (result.isDismissed) {
          this._utilService.hideLoading();
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_DELETE_CUSTOMER" });
      });
  }
}
